import { useGuestSiteTelemetry } from '@apps/guest/GuestSite.telemetry';
import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { useCallback } from 'react';
import { useGuestSitePageChanged } from '../../common/utils/useGuestSitePageChanged';
import type { WritableUtmParameters } from '@shared/utils/utmParameters';

export const useLayoutBrannanController = (pages: ReadonlyArray<EventPageFragment>) => {
  const telemetry = useGuestSiteTelemetry();

  useGuestSitePageChanged(pages);

  // MENU
  const handleMenuClicked = useCallback(
    (pageClicked: string, utm?: WritableUtmParameters) => {
      telemetry.navMenuItemClicked(pageClicked, utm);
    },
    [telemetry],
  );

  const handleMenuOpenedChange = useCallback(
    (opened: boolean) => {
      telemetry.navMenuOpenedChange(opened ? 'opened' : 'closed');
    },
    [telemetry],
  );

  // WELCOME SECTION
  const handleWelcomeRSVPButtonClicked = useCallback(() => {
    telemetry.welcomeRSVPButtonClicked();
  }, [telemetry]);

  //Footer Section
  const handleFooterButtonClicked = useCallback(
    (item: string) => {
      telemetry.footerItemClicked(item);
    },
    [telemetry],
  );

  //Edit Event
  const handleEditEventClicked = useCallback(() => {
    telemetry.editEventClicked();
  }, [telemetry]);

  return {
    handleMenuClicked,
    handleWelcomeRSVPButtonClicked,
    handleFooterButtonClicked,
    handleMenuOpenedChange,
    handleEditEventClicked,
  };
};
